module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/03bd480912e01b6328db7bebe2ddc598.png";